"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _item = _interopRequireDefault(require("./style/item"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var OptionsItem = function OptionsItem(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      style = _ref.style;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [theme, style]);
  return _react["default"].createElement(_item["default"], {
    theme: memoTheme
  }, children);
};

OptionsItem.propTypes = {
  children: _propTypes["default"].any,
  theme: _propTypes["default"].object
};
var _default = OptionsItem;
exports["default"] = _default;